var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M.667 9.667h14.666V13H.667V9.667Z","fill":"#FF3D00"}}),_c('path',{attrs:{"d":"M.667 6.333h14.666v3.334H.667V6.333Z","fill":"#3F51B5"}}),_c('path',{attrs:{"d":"M.667 3h14.666v3.333H.667V3Z","fill":"#E0E1E2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }